import axios from "@/modules/axios";

export default {
	namespaced: true,

	state: {
		featured: [],
		items: {
			data: [],
			meta: {} 
		} 
	},

	mutations: {
		featured(state, data) {
			state.featured = data;
		},
		items(state, items) {
			state.items = {
				meta: items.meta,
				data: [...state.items.data, ...items.data]
			};
		},
		visited(state, data) {
			const arrays = [state.featured, state.items.data];
			arrays.forEach(array => {
				const item = array.find(x => x.id === data.id);
				if(item) item.visited = true;
			})
		}
	},

	actions: {
		async getItems({state, commit}, {more} = {}) {
			const {data} = await axios.get("client/news-items", {params: {
				count: 5,
				page: more ? state.items.meta.current_page+1 : 1,
				sort: "-published_at",
				filter: {featured: false},
				fields: {news_items: "id,slug,title,published_at,subtitle"}
			}});
			commit("items", data);
		},
		async getFeatured({commit}) {
			const {data: {data}} = await axios.get("client/news-items", {params: {
				filter: {featured: true},
				fields: {news_items: "id,slug,title,published_at,subtitle"}
			}});

			commit("featured", data);
		}
	},

	getters: {
		items(state) {
			return state.items;
		},
		featured(state) {
			return state.featured;
		},
		allNews(state, getters) {
			return [...getters.items.data.slice(0, 5), ...getters.featured];
		}
	} 
};
